import type { InputHTMLAttributes } from 'react';
import './styles.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  help?: string;
  fullWidth?: boolean;
}

export const Input = ({
  label,
  error,
  help,
  fullWidth = false,
  className = '',
  required,
  id,
  ...props
}: InputProps) => {
  const inputId = id || `input-${label?.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className={`form-group ${fullWidth ? 'form-group--fullwidth' : ''}`}>
      {label && (
        <label
          htmlFor={inputId}
          className={`form-label ${required ? 'form-label--required' : ''}`}
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`form-input ${error ? 'form-input--error' : ''} ${className}`}
        aria-invalid={!!error}
        aria-describedby={
          error ? `${inputId}-error` : help ? `${inputId}-help` : undefined
        }
        required={required}
        {...props}
      />
      {error && (
        <span id={`${inputId}-error`} className="form-error">
          {error}
        </span>
      )}
      {help && !error && (
        <span id={`${inputId}-help`} className="form-help">
          {help}
        </span>
      )}
    </div>
  );
};
